import React, { memo } from 'react';
import { css, useTheme } from '@emotion/react';
import type { ArrayEntryType, DLClickEventHandlerProps, TabsEntryType } from 'tsconfig/types';
import { MainNavBar } from '../MainNavBar/MainNavBar';
import { HeaderLogo } from '../SearchNavBar/HeaderLogo/HeaderLogo';

export type MainNavBarProps = {
  cmsMainNav?: ArrayEntryType<TabsEntryType>;
  globalHeaderHeight: number;
  dlClickEventHandler: DLClickEventHandlerProps;
};

export const StickyMainNavBar = memo(({ globalHeaderHeight, cmsMainNav, dlClickEventHandler }: MainNavBarProps) => {
  const theme = useTheme();
  const widgetTheme = theme.widgets.GlobalHeader || {};
  const media = theme.breakpoints.lg ? theme.breakpoints.lg.replace('@media', '') : '';

  const wrapper = css`
    ${widgetTheme?.stickymainNavWrapper}
  `;

  const desktopOnly = css`
    display: none;
    @media ${media} {
      display: block;
    }
  `;

  return (
    <div css={wrapper} className="sticky-nav-bar">
      <div css={desktopOnly}>
        <HeaderLogo isSticky={true} />
      </div>
      <MainNavBar
        globalHeaderHeight={globalHeaderHeight}
        cmsMainNav={cmsMainNav}
        dlClickEventHandler={dlClickEventHandler}
      />
    </div>
  );
});
